import React, { useEffect, useState } from 'react'
import WhatsappButton from '../tools/WhatsappButton'
import { useParams } from 'react-router-dom'
import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore'
import { db } from '../../firebaseConfig/firebase'

const ProductShow = () => {
    const location = window.location.origin
    const { ProductId } = useParams()
    const [product, setProduct] = useState(null)
    const [whatsAppPhoneNumber, setWhatsAppPhoneNumber] = useState("")
    const [whatsAppDefaultText, setWhatsAppDefaultText] = useState("")
    const [shippingPrice, setShippingPrice] = useState(0)
    const [selectedImage, setSelectedImage] = useState("")

    const GetProduct = async function () {

        if (ProductId) {
            const ref = await doc(db, 'products', ProductId)
            const productDoc = await getDoc(ref)
            if (productDoc.exists) {
                setProduct({ id: productDoc.id, ...productDoc.data() });
                setSelectedImage(productDoc.data().image)
            } else {
                console.log("Producto no encontrado");
            }
        }
    }

    const getGeneralParameters = async () => {
        await getWhatsAppPhoneNumber()
        await getWhatsAppDefaultText()
        await getShippingPrice()
    }

    const getWhatsAppPhoneNumber = async () => {
        if (whatsAppPhoneNumber === "") {
            const whatsAppPhoneNumberQuery = query(collection(db, "parameters"), where("code", "==", "whatsAppPhoneNumber"));
            const whatsAppPhoneNumberDocs = await getDocs(whatsAppPhoneNumberQuery)
            if (whatsAppPhoneNumberDocs.docs.length > 0) {
                setWhatsAppPhoneNumber(whatsAppPhoneNumberDocs.docs[0].data().value)
            }
        }
    }

    const getWhatsAppDefaultText = async () => {
        if (whatsAppDefaultText === "") {
            const whatsAppDefaultTextQuery = query(collection(db, "parameters"), where("code", "==", "whatsAppDefaultText"));
            const whatsAppDefaultTextDocs = await getDocs(whatsAppDefaultTextQuery)
            if (whatsAppDefaultTextDocs.docs.length > 0) {
                setWhatsAppDefaultText(whatsAppDefaultTextDocs.docs[0].data().value)
            }
        }
    }

    const getShippingPrice = async () => {
        if (shippingPrice === 0) {
            const shippingPriceQuery = query(collection(db, "parameters"), where("code", "==", "ShippingPrice"));
            const shippingPriceDocs = await getDocs(shippingPriceQuery)
            if (shippingPriceDocs.docs.length > 0) {
                setShippingPrice(shippingPriceDocs.docs[0].data().value)
            }
        }
    }

    useEffect(() => {
        getGeneralParameters()
        GetProduct()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ProductId])

    return (
        <>
            {

                product ? (
                    <div className="Container ms-3 me-3">
                        <div>
                            <h1>{product.brand.name}</h1>
                            <h2>{product.name}</h2>
                        </div>
                        <div>
                            <img style={{ width: "90%" }} src={selectedImage} alt={product.name} />
                            <div className='row'>
                                <div className="col-6" onClick={() => setSelectedImage(product.image)}>
                                    <img style={{ width: "75%" }} src={product.image} alt={product.name} />
                                </div>
                                <div className="col-6" onClick={() => setSelectedImage(product.image2)}>
                                    <img style={{ width: "75%" }} src={product.image2} alt={product.name} />
                                </div>
                            </div>
                            <h3 className='text-start'>{product.price > 0 ? "₡" + product.price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : "Cotizar"}</h3>
                            <p className='text-start'>Envío: ₡{parseFloat(shippingPrice).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                            <p className='text-start'>{product.description}</p>
                            <p className='text-start'>Categorías: {product.categories.map(item => item.name).join(", ")}</p>
                        </div>
                        <div className="modal-footer">
                            <WhatsappButton text={`${whatsAppDefaultText} ${product.brand.name} ${product.name} ${location}/Product/${product.id}`} whatsAppPhoneNumber={whatsAppPhoneNumber} />
                        </div>
                    </div>
                ) : (<></>)
            }
        </>
    )
}

export default ProductShow